"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exclusionGroupsApi = exports.get = void 0;
const createApi_1 = require("../../helpers/createApi");
const list = (caller) => ({ accountId, filters = {}, ...getParameters }) => {
    const url = `/accounts/${accountId}/exclusion-groups`;
    const { state, status, ...otherFilters } = filters;
    const filterState = state?.map(({ value, strict }) => `${strict ? '~' : ''}${value}`);
    const filterStatus = status?.map(({ value, strict }) => `${strict ? '~' : ''}${value}`);
    return caller(url).get({ ...getParameters, ...otherFilters, state: filterState, status: filterStatus });
};
const get = (caller) => ({ accountId, groupId }) => {
    return caller(`/accounts/${accountId}/exclusion-groups/${groupId}`).get();
};
exports.get = get;
const patch = (caller) => ({ accountId, allocation, exclusionGroupId, tests, name }) => {
    const url = `/accounts/${accountId}/exclusion-groups/${exclusionGroupId}`;
    return caller(url).patch({ allocation, tests, name });
};
const post = (caller) => ({ accountId, allocation, name, tests }) => {
    const url = `/accounts/${accountId}/exclusion-groups`;
    return caller(url).post({ allocation, name, tests });
};
const remove = (caller) => ({ groupId, accountId }) => {
    const url = `/accounts/${accountId}/exclusion-groups/${groupId}`;
    return caller(url).delete();
};
exports.exclusionGroupsApi = (0, createApi_1.createAPIFactory)({
    list,
    patch,
    post,
    get: exports.get,
    remove,
});
//# sourceMappingURL=api.js.map